import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { Popover } from '@headlessui/react';
import { usePopper } from 'react-popper';
import { jsx as _jsx } from "react/jsx-runtime";
var SimplePopover = function SimplePopover(_ref) {
  var children = _ref.children,
    referenceElement = _ref.referenceElement,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    popperElement = _useState2[0],
    setPopperElement = _useState2[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'flip',
        enabled: true,
        options: {
          flipVariations: true
        }
      }, {
        name: 'offset',
        options: {
          offset: [0, 4]
        }
      }, {
        name: 'preventOverflow',
        enabled: true
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  return /*#__PURE__*/_jsx(Popover, _objectSpread(_objectSpread({
    className: "relative z-50 m-2 rounded-sm bg-white shadow-lg",
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), {}, {
    children: children
  }));
};
export default SimplePopover;